import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { CustomMessagesService } from '@core/errors/custom-messages.service';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { startOfYear, sub } from 'date-fns';
import { sentry } from 'sentry';
import { environment } from '../../../../environments/environment';
import { ExportDialogTypeEnum } from '../export-dialog/export-dialog.types';
import { ExportDialogService } from '../export-dialog/services/export-dialog.service';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';

@Component({
  templateUrl: './export-dialog-imr.component.html',
  styleUrls: ['./export-dialog-imr.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ExportDialogImrComponent {
  public email: string;
  public isExporting: boolean;

  public control = new FormControl(null, {
    validators: [Validators.required]
  });

  public maxDate: Date;
  public minDate: Date;

  constructor(
    public readonly matDialogRef: MatDialogRef<ExportDialogImrComponent>,
    private readonly authenticationService: AuthenticationService,
    private readonly customMessageService: CustomMessagesService,
    private readonly exportDialogService: ExportDialogService,
    private readonly fuseProgressBarService: FuseProgressBarService,
    private readonly fuseTranslationLoaderService: FuseTranslationLoaderService

  ) {
    this.isExporting = false;
    this.email = this.authenticationService.user && this.authenticationService.user.email;
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });

    this.maxDate = new Date();
    this.minDate = startOfYear(sub(new Date(), { years: 2 }));
  }

  public async export(): Promise<void> {
    try {
      this.isExporting = true;
      this.fuseProgressBarService.show();

      const input = this.exportDialogService.toCreateExportParams({
        type: ExportDialogTypeEnum.maintenancesImr,
        where: {
          yearAndMonth: this.control.value.value,
        },
      });

      await this.exportDialogService.createExport(input);

      this.customMessageService.success('EXPORT_DIALOG_IMR.MESSAGES.EXPORT_SUCCESS', {}, {
        text: 'Ver exportações',
        callback: () => {
          location.href = environment.MOUNTDOOM_2_URL + '/#/exportacoes';
        }
      });
    } catch (err) {

      console.error('Error exporting IMR', err);
      sentry.captureException(err);

      this.customMessageService.error('EXPORT_DIALOG_IMR.MESSAGES.EXPORT_ERROR');
    } finally {
      this.isExporting = false;
      this.matDialogRef.close();
      this.fuseProgressBarService.hide();
    }
  }
}
